export interface Category {
  id: string;
  nameKey: string;
  descKey: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'categories.shoes',
    descKey: 'categories.shoes_desc',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
  },
  {
    id: 'hoodies',
    nameKey: 'categories.hoodies',
    descKey: 'categories.hoodies_desc',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 'tshirts',
    nameKey: 'categories.tshirts',
    descKey: 'categories.tshirts_desc',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
  },
  {
    id: 'jackets',
    nameKey: 'categories.jackets',
    descKey: 'categories.jackets_desc',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-medal-line',
  },
  {
    id: 'pants',
    nameKey: 'categories.pants',
    descKey: 'categories.pants_desc',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
  },
  {
    id: 'headwear',
    nameKey: 'categories.headwear',
    descKey: 'categories.headwear_desc',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-3-line',
  },
  {
    id: 'sets',
    nameKey: 'categories.sets',
    descKey: 'categories.sets_desc',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
  },
  {
    id: 'underwear',
    nameKey: 'categories.underwear',
    descKey: 'categories.underwear_desc',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
  },
  {
    id: 'jersey',
    nameKey: 'categories.jersey',
    descKey: 'categories.jersey_desc',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
  },
  {
    id: 'accessories',
    nameKey: 'categories.accessories',
    descKey: 'categories.accessories_desc',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
  },
  {
    id: 'bags',
    nameKey: 'categories.bags',
    descKey: 'categories.bags_desc',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
  },
  {
    id: 'belts',
    nameKey: 'categories.belts',
    descKey: 'categories.belts_desc',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
  },
  {
    id: 'perfumes',
    nameKey: 'categories.perfumes',
    descKey: 'categories.perfumes_desc',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
  },
  {
    id: 'other',
    nameKey: 'categories.other',
    descKey: 'categories.other_desc',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
  },
];